import React from 'react';

const LOGO_ISOTIPO = "https://customer-assets.emergentagent.com/job_team-share-pro/artifacts/ees3h8gt_logo-v1.svg";
const LOGO_HORIZONTAL = "https://customer-assets.emergentagent.com/job_team-share-pro/artifacts/tw5e6okm_logo-horizontal.svg";

export function LogoHorizontal({ className = '', size = 'md' }) {
    const heights = { sm: 32, md: 44, lg: 56, xl: 72 };
    return (
        <img
            src={LOGO_HORIZONTAL}
            alt="4everSync"
            height={heights[size]}
            style={{ height: heights[size], width: 'auto' }}
            className={className}
            data-testid="logo-horizontal"
        />
    );
}

export function LogoIsotipo({ size = 56, className = '' }) {
    return (
        <img
            src={LOGO_ISOTIPO}
            alt="4everSync"
            width={size}
            height={size}
            style={{ width: size, height: size }}
            className={className}
            data-testid="logo-isotipo"
        />
    );
}
